import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {DetailsTabContentWrapper} from '@/features/projects/components/details-tab-content-wrapper/DetailsTabContentWrapper'
import {StyledSkeletonSection, StyledSkeletonSectionBody, StyledSkeletonSectionHeading} from './style'

const LABEL_WIDTHS = [72, 94, 86, 110, 68, 100, 78, 92]
const VALUE_WIDTHS = [130, 150, 120, 170, 110, 140, 160, 125]

const SkeletonField = ({index = 0}: {index?: number}) => (
    <DetailsField>
        <Skeleton width={LABEL_WIDTHS[index % LABEL_WIDTHS.length]} height={14} />
        <Skeleton width={VALUE_WIDTHS[index % VALUE_WIDTHS.length]} height={16} />
    </DetailsField>
)

const SkeletonSection = ({fields, cols = 2}: {fields: number; cols?: number}) => (
    <StyledSkeletonSection>
        <StyledSkeletonSectionHeading>
            <Skeleton width={140} height={20} />
        </StyledSkeletonSectionHeading>
        <StyledSkeletonSectionBody>
            <Grid columns={cols} gap={3} fullWidth>
                {Array.from({length: fields}).map((_, i) => (
                    <SkeletonField key={i} index={i} />
                ))}
            </Grid>
        </StyledSkeletonSectionBody>
    </StyledSkeletonSection>
)

export const ProjectDetailsProjectDataSkeleton = () => (
    <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
        <DetailsTabContentWrapper>
            <Grid columns={2} gap={4}>
                <SkeletonSection fields={8} />
                <SkeletonSection fields={8} />
                <SkeletonSection fields={4} />
                <SkeletonSection fields={6} />
                <GridItem spanColumn={2}>
                    <SkeletonSection fields={4} cols={4} />
                </GridItem>
            </Grid>
        </DetailsTabContentWrapper>
        <Divider direction="horizontal" />
        <DetailsTabContentWrapper>
            <Flexbox direction="column" gap={6} fullWidth>
                <Skeleton width={200} height={24} />
                <Grid columns={3} gap={4} fullWidth>
                    <SkeletonSection fields={2} cols={1} />
                    <SkeletonSection fields={2} cols={1} />
                    <SkeletonSection fields={2} cols={1} />
                </Grid>
            </Flexbox>
        </DetailsTabContentWrapper>
    </ScrollArea>
)
